import { TranslateModule } from '@ngx-translate/core';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmsComponent } from './sms.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule.forChild(),
    ],
    declarations: [SmsComponent],
    exports: [SmsComponent]
})
export class SmsModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SmsModule,
            providers: []
        }
    }
}
